import React from 'react'
import { View, Icon } from '../primitives'

const Container = View.extend.attrs({ px: 2 })`
opacity: 0.8;
  &:hover {
    opacity: 0.6;
  }
  transition: all 250ms ease;
  cursor: pointer;
  display:none;
`

const Heart = Icon.extend.attrs({
  icon: props => (props.active ? 'heart-fill' : 'heart-outline'),
  m: 4
})`
  position: absolute;
  right: 0;
  top: 0;
`

export default ({ onClick, ...props }) => (
  <Container onClick={onClick}>
    <Heart {...props} />
  </Container>
)
